import type { Middleware } from '@reduxjs/toolkit';
import { addMessage, incrementUnreadCount } from '@/store/slices/chatSlice';

export const notificationMiddleware: Middleware = store => next => action => {
  const result = next(action);
  // When a bot message is added
  if (addMessage.match(action)) {
    const { personaName, message } = action.payload;
    
    // If it's a bot message
    if (message.sender === 'bot') {
      const currentState = store.getState();
      const currentPersona = currentState.app.currentPersona;
      
      // If the persona that received the message is not the currently selected one
      if (currentPersona && currentPersona.name !== personaName) {
        // Increment the unread message counter
        store.dispatch(incrementUnreadCount(personaName));
        
        // Show a browser notification if permitted
        if ('Notification' in window && Notification.permission === 'granted') {
          new Notification(`Risposta da ${personaName}`, {
            body: message.text,
            icon: '/vite.svg',
            tag: `persona-${personaName}`,
          });
        }
      }
    }
  }
  return result;
}; 